export function sendPostMessage(message) {
  if (window.parent && document.referrer) {
    window.parent.postMessage(JSON.stringify(message), document.referrer);
  } else {
    // eslint-disable-next-line
    console.warn('postMessage() not supported in this context, but the message would be:', JSON.stringify(message, null, 2));
  }
}

export function receivePostMessage(handler) {
  window.jQuery(window).on('message', async ({
    originalEvent: {
      data = {},
    },
  }) => {
    handler(data);
  });
}



// WEBPACK FOOTER //
// ./src/helpers/embedded.js